import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  delete_icon,
  edit_icon,
  search_icon,
  view_icon,
} from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";

const RolesCompany = () => {
  const navigate = useNavigate();
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const company = JSON.parse(localStorage.getItem("company") ?? "{}");
  const user_details = JSON.parse(localStorage.getItem("user_details") ?? "{}");
  const [page, setPage] = useState(1);

  // console.log("company", company);
  console.log("user_details", user_details);

  const [pagination, setPagination] = useState("");

  const [popup, setPopup] = useState(false);

  const [owners, setOwners] = useState([]);
  const [search, setSearch] = useState("");

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Role",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <p>
              {value?.includes(`${company?.name} ${"Company Admin"}`)
                ? value?.replace(company?.name, "")
                : value}
            </p>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          const hasPermission = givenpermissions?.includes(
            "CAN-Status-KNF_COMPANY_USER_ROLES",
          );

          const adminCreated = row?.original?.created_by;
          const sameUser = user_details?.knf_role_id === row?.original?.id;

          const isDisabled = !adminCreated || !hasPermission || sameUser;

          return (
            <div>
              <button
                disabled={isDisabled}
                onClick={() => {
                  if (!isDisabled) {
                    handleStatus(row.original.id);
                  }
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0 f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18 ${
                  isDisabled ? "opacity-50" : ""
                }`}
              >
                {value ? "Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          const sameUser = user_details?.knf_role_id === row?.original?.id;
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                {givenpermissions?.includes("CAN-View-KNF_COMPANY_ROLES") && (
                  <button
                    onClick={() => {
                      navigate("/CompanyAddRoles", {
                        state: { type: "view", id: row.original.id },
                      });
                      // AdminView(row.original.id, "view");
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
                {/* {givenpermissions?.includes("CAN-View-ADMINS") && ( */}
                {/* <button
                  onClick={() => {
                    navigate('/CompanyAddRoles', { state: { type: "view", id: row.original.id  } })
                    // AdminView(row.original.id, "view");
                  }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className="mx-2 edit-btn " />
                </button> */}
                {/* )} */}
                {givenpermissions?.includes("CAN-Edit-KNF_COMPANY_ROLES") && (
                  <>
                    {row.original.created_by && (
                      <button
                        onClick={() => {
                          navigate("/CompanyAddRoles", {
                            state: { type: "edit", id: row.original.id },
                          });
                          // AdminView(row.original.id, "edit");
                        }}
                        disabled={sameUser}
                        className="cust-btn "
                      >
                        <img src={edit_icon} alt="" className=" edit-btn " />
                      </button>
                    )}
                  </>
                )}
                {givenpermissions?.includes("CAN-Delete-KNF_COMPANY_ROLES") && (
                  <>
                    {row.original.created_by && (
                      <button
                        onClick={() => setPopup(row.original.id)}
                        // onClick={() => setDeletePopup(row.original.id)}
                        className="cust-btn "
                        disabled={sameUser}
                      >
                        <img src={delete_icon} alt="" className=" edit-btn " />
                      </button>
                    )}
                  </>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [],
  );

  const handleStatus = async (id) => {
    get(URL.ROLE_STATUS_COMPANY + id)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getRoles("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleDelete = async () => {
    get(URL.DELETE_ROLE_COMPANY + popup)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          setPopup(false);
          getRoles("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getRoles = (search_) => {
    let formdata = new FormData();
    // formdata.append("page", page);
    formdata.append("type", 4);
    formdata.append("search", search_);
    formdata.append("company_id", company?.id);
    formdata.append("created_by", user_details?.id);
    setSearch(search_);
    post(URL.KNF_COMPANY_ROLES_LIST, formdata)
      .then((res) => {
        if (res?.lists?.length > 0) {
          let filtered = res?.lists?.filter(
            (i) =>
              i.id == user_details?.knf_role_id ||
              i.created_by == user_details?.id,
          );

          setOwners(res?.lists);
          // setPagination(res?.pagination_meta);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getRoles(search);
  }, []);

  console.log("page", page);

  return (
    <div className="dashRightView">
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{owners.length}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => getRoles(e.target.value)}
              value={search}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
          {givenpermissions?.includes("CAN-Add-KNF_COMPANY_ROLES") && (
            <button
              onClick={() =>
                navigate("/CompanyAddRoles", { state: { type: "add" } })
              }
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
            >
              {" "}
              + Add Roles
            </button>
          )}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pageno={page}
        // pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                No
              </button>
              <button
                onClick={() => {
                  handleDelete(false);
                }}
                className="back-btn f2 w-40"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RolesCompany;
